export type IValidationError = {
    name: string;
    message: string;
};

export type IResultStatus = {
    success: boolean;
    errorMessage: string;
    errorCode: string;
    validationErrors: IValidationError[];
};

export type UserCommunicationButton = {
    text?: string;
    buttonActionType?: number;
    telemetryClickName?: string;
};

export type IUserCommunication = {
    title?: string;
    message?: string;
    imageUrl?: string;
    displayType?: string;
    closeActionType?: number;
    telemetryDisplayName?: string;
    buttons?: UserCommunicationButton[];

    nextClick?: () => void;
    backClick?: () => void;
};

export type ICommonServiceOutputBase = {
    resultStatus: IResultStatus;
    userCommunication?: IUserCommunication;
};

export type ICommonServiceOutput<T> = ICommonServiceOutputBase & { data: T };

export type IServiceError<T = undefined> = {
    commonServiceOutput: ICommonServiceOutput<T>;
};

export type PascalToKebab<
    S extends string,
    First extends boolean = true,
> = S extends `${infer T}${infer U}`
    ? `${T extends Capitalize<T> ? (First extends true ? "" : "-") : ""}${Lowercase<T>}${PascalToKebab<U, false>}`
    : S;

export const isClient = typeof window !== "undefined";
